<template>
  <div class="activity-library-drafts-table">
    <ActivityLibraryTable
      :data="data"
      :count="count"
      :title="title === 'ACTIVITIES' ? 'Archived activities' : title"
      @previewActivity="previewActivity($event)"
      :currentView="currentView"
      :isDisplayViews="true"
      :views="archivedViews"
      @changeView="changeView"
      @onSortColumn="onSortColumn"
      @onPageChange="onPageChange"
      :pagination="pagination"
      :isPaginate="true"
      :previewSelectedId="previewSelectedId"
      tableType="Archived"
    >
    </ActivityLibraryTable>
  </div>
</template>

<script>
import ActivityLibraryTable from "@/components/activity-library/activity-library-table";
import * as columnNames from "@/constants/activity-library-and-configurator-component/column-names";
import _ from "lodash";

export default {
  name: "ArchivedTable",
  components: {
    ActivityLibraryTable
  },
  data() {
    return {};
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    count: {},
    currentView: {
      type: Number
    },
    views: {},
    title: {},
    pagination: {},
    previewSelectedId: null
  },
  computed: {
    archivedViews() {
      const archivedViews = _.cloneDeep(this.views);
      archivedViews["1"].push(columnNames.ACTION);
      archivedViews["2"].push(columnNames.ACTION);
      archivedViews["1"].unshift(columnNames.PREVIEW);
      archivedViews["2"].unshift(columnNames.PREVIEW);
      archivedViews["1"].unshift(columnNames.EMPTY_PIN);
      archivedViews["2"].unshift(columnNames.EMPTY_PIN);
      return archivedViews;
    }
  },
  methods: {
    onSortColumn(eventData) {
      this.$emit("onSortColumn", eventData);
    },
    onPageChange(direction) {
      this.$emit("onPageChange", { direction, tableTitle: this.title });
    },
    changeView(view) {
      this.$emit("changeView", view);
    },
    previewActivity(previewActivityObj) {
      this.$emit("previewActivity", previewActivityObj);
    }
  }
};
</script>

<style scoped lang="scss">
.activity-library-drafts-table {
  &__collapse-row {
    background-color: white;
  }
}
</style>
